import React from 'react';
import { styled } from '@linaria/react';
import { ContentWrapper } from '@daedalus/atlas/helpers/ContentWrapper';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const StyledGrid = /*#__PURE__*/styled('div')({
  name: "StyledGrid",
  class: "s14ba4ry",
  propsAsIs: false
});
export const PaymentInformationSkeleton = () => {
  return <ContentWrapper paddingY="s400">
      <Grid alignItems="center">
        <StyledGrid>
          <SkeletonLoader height={16} width={120} />
          <SkeletonLoader height={16} width={120} />
        </StyledGrid>
      </Grid>
      <StyledGrid>
        <SkeletonLoader height={36} width={160} marginTop={24} marginBottom={8} />
        <SkeletonLoader height={36} width={160} marginTop={24} marginBottom={8} />
      </StyledGrid>
    </ContentWrapper>;
};
export const PriceDetailsSkeleton = () => {
  return <SkeletonLoader height={20} width={75} marginBottom={6} />;
};
export const TotalPriceSkeleton = () => {
  return <SkeletonLoader height={24} width={90} marginBottom={4} />;
};
export const TotalPriceTitleSkeleton = () => {
  return <SkeletonLoader height={24} width={90} />;
};

require("./Skeleton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Skeleton.tsx");